// extracted by mini-css-extract-plugin
export default {"headingH2":"maintenance_headingH2__kDhLb","breadcrumbs":"maintenance_breadcrumbs__RxAJn","aboutp":"maintenance_aboutp__njEcg","aboutH3":"maintenance_aboutH3__RwqVS"};